import React, { useCallback, useState, useEffect } from "react";
import Header from "../components/Header";
import {
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Modal,
  ToggleButton,
  Switch,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ModalError from "../components/Generics/ModalError";
import { actions, logout, service } from "../model";
import ModalNewPractice from "../components/Generics/ModalNewPractice";
import { useNavigate } from "react-router-dom";
import { validationCreatePractice } from "../utils/validation";
import axios from "axios";

const Home = ({ isToolsDomain }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [practice, setPractice] = useState(null);

  const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");

  const userId = `${reduxObject?.user?.id || ""}`;

  const practices = useSelector(
    (state) => state.user?.redux_object?.practices || [],
  );

  const user = useSelector((state) => state.user?.redux_object?.user || []);
  const [isAdmin, setIsAdmin] = useState(user?.admin === 1);

  const approvedPractices = practices.filter(
    (practice) => practice.practice_worked === 1,
  );

  const pendingPractices = practices.filter(
    (practice) => practice.status === "sent" && practice.practice_worked === 0,
  );

  const draftPractices = practices.filter(
    (practice) => practice.status === "saved",
  );

  const dispatch = useDispatch();

  let newIdPractice = localStorage.getItem("newIdPractice");
  let AML = localStorage.getItem("AML");

  localStorage.setItem("newIdPractice", null);

  localStorage.setItem("AML", null);

  const [visibleSectionApproved, setVisibleSectionApproved] = useState(false);
  const [visibleSectionPending, setVisibleSectionPending] = useState(false);
  const [visibleSectionDraft, setVisibleSectionDraft] = useState(false);

  const [selectedPracticeId, setSelectedPracticeId] = useState(null);

  const [deletePractice, setDeletePractice] = useState(false);

  const openModalDeletePractice = (practice_id) => {
    setSelectedPracticeId(practice_id);
    setDeletePractice(true);
  };

  const closeDeletePracticeModal = () => {
    setDeletePractice(false);
  };

  const toggleSectionApproved = useCallback(() => {
    setVisibleSectionApproved((prev) => !prev);
  }, []);

  const toggleSectionPending = useCallback(() => {
    setVisibleSectionPending((prev) => !prev);
  }, []);

  const toggleSectionDraft = useCallback(() => {
    setVisibleSectionDraft((prev) => !prev);
  }, []);

  const deletePracticeCall = async () => {
    try {
      if (selectedPracticeId) {
        await service.delete(selectedPracticeId);
      }
      await dispatch(actions.getPractice());
    } catch (error) {
      console.error(error);
    }

    setDeletePractice(false);
  };

  // modal new practice

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalClick = (objectInfo) => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setPractice(null);
  };

  const handlePracticeUpdate = (updatedAssignment) => {
    setPractice(updatedAssignment);
  };

  const [updated, setUpdated] = useState(false);
  const [fieldErrors, setFieldErrors] = useState([]);

  useEffect(() => {
    if (practices.length > 0 && updated) {
      const savedPractices = practices.filter(
        (practice) => practice.status === "saved",
      );

      const lastPractice = savedPractices.at(-1);

      if (lastPractice) {
        const newId = String(lastPractice.id);
        setModalOpen(false);
        navigate(`/practice/${newId}`, { replace: false });
      }

      setUpdated(false);
    }
  }, [practices, updated, navigate]);

  const createPractice = async () => {
    try {
      const errors = validationCreatePractice(practice);

      if (errors.length === 0) {
        await service.store(practice, `1`, userId, "1");
        await dispatch(actions.getPractice());
        setTimeout(() => {
          setUpdated(true);
        }, 1000);
      } else {
        setFieldErrors(errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // OLD CHANGE-ROLE bug - return 401 nessun logout
  // const changeRoleUser = async () => {
  //   const accessToken = reduxObject ? reduxObject.accessToken : null;

  //   try {
  //     const response = await axios.get(
  //       process.env.REACT_APP_API_ENDPOINT + "change-role",
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //           Authorization: "Bearer " + accessToken,
  //         },
  //       },
  //     );
  //     if (response.status === 200) {
  //       const token = localStorage.getItem("token");
  //       const email = localStorage.getItem("email");

  //       dispatch(actions.loginLexiaTools(token, email));
  //     }

  //     return response.data;
  //   } catch (error) {
  //     console.error("Errore durante il cambio ruolo:", error);
  //     throw error;
  //   }
  // };

  // switch admin-user new change-role
  const changeRoleUser = async () => {
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + "change-role",
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + accessToken,
          },
        },
      );
      if (response.status === 200) {
        const token = localStorage.getItem("token");
        const email = localStorage.getItem("email");
        dispatch(actions.loginLexiaTools(token, email));
      }

      return response.data;
    } catch (error) {
      console.error("Errore durante il cambio ruolo:", error);

      if (error?.response?.status === 401) {
        window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
        return;
      }

      throw error;
    }
  };

  useEffect(() => {
    if (user?.admin !== undefined) {
      setIsAdmin(user.admin === 1);
    }
  }, [user]);

  const handleToggle = async (event) => {
    setIsAdmin(event.target.checked);

    dispatch({ type: "GLOBAL_LOADING_START" });

    try {
      await changeRoleUser();

      const id_token = localStorage.getItem("id_token");
      const access_token = localStorage.getItem("access_token");
      const email_user = localStorage.getItem("email_user");

      if (id_token && access_token && email_user) {
        await dispatch(
          actions.loginLexiaTools(email_user, id_token, access_token),
        );
      }
    } catch (error) {
      console.error("Errore nel cambio ruolo", error);
    } finally {
      setTimeout(() => {
        dispatch({ type: "GLOBAL_LOADING_STOP" });
      }, 3000);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <Header user={user} />
        </div>

        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Grid
            item
            container
            xs={11}
            sm={10}
            spacing={4}
            style={{
              marginTop: "120px",
              marginBottom: "30px",
              display: "flex",
              height: "30px",
              justifyContent: "center",
            }}
          >
            {approvedPractices.length !== 0 && (
              <>
                {/* APPROVATE  */}
                <Grid
                  item
                  xs={11}
                  md={8}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "20px",
                  }}
                >
                  <Grid item xs={11}>
                    {" "}
                    {approvedPractices.length > 0 ? (
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          fontSize: {
                            xs: "18px !important",
                            sm: "20px !important",
                            md: "22px !important",
                          },
                          fontWeight: 600,
                        }}
                      >
                        Richieste approvate
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div onClick={toggleSectionApproved}>
                      <div
                        className={
                          visibleSectionApproved
                            ? "icon-less-practice"
                            : "icon-plus-practice"
                        }
                      />
                    </div>
                  </Grid>
                </Grid>

                {approvedPractices
                  .slice()
                  .reverse()
                  .map((practice) => {
                    let parsedPractice = practice.practice;

                    try {
                      while (typeof parsedPractice === "string") {
                        parsedPractice = JSON.parse(parsedPractice);
                      }
                    } catch (error) {
                      console.error(error);
                      parsedPractice = {};
                    }

                    const datePart = new Date(
                      practice.updated_at,
                    ).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });

                    const timePart = new Date(
                      practice.updated_at,
                    ).toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <Grid
                        item
                        xs={11}
                        md={8}
                        component={Link}
                        to={`/practice/${practice.id}`}
                        key={practice.id}
                        style={{
                          paddingTop: "25px",
                          width: "100%",
                          display: visibleSectionApproved ? "block" : "none",
                          textDecoration: "none",
                        }}
                      >
                        <div className="card_practice">
                          <Link
                            to={`/practice/${practice.id}`}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                marginBottom: "0px",
                                fontSize: "16px",
                                marginLeft: "20px",
                                marginRight: "20px",
                              }}
                            >
                              #{practice.id} -{" "}
                              {parsedPractice?.Incarico?.Nome_pratica || "N/A"}{" "}
                              - Approvata il {datePart} alle {timePart}{" "}
                            </Typography>
                            <Typography variant="body2"></Typography>
                          </Link>
                        </div>
                      </Grid>
                    );
                  })}
              </>
            )}

            {pendingPractices.length !== 0 && (
              <>
                <Grid
                  item
                  xs={11}
                  md={8}
                  style={{
                    display: "flex",
                    marginTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <Grid item xs={11}>
                    {" "}
                    {pendingPractices.length > 0 ? (
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          fontSize: {
                            xs: "18px !important",
                            sm: "20px !important",
                            md: "22px !important",
                          },
                          fontWeight: 600,
                        }}
                      >
                        Richieste in attesa di approvazione
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div onClick={toggleSectionPending}>
                      <div
                        className={
                          visibleSectionPending
                            ? "icon-less-practice"
                            : "icon-plus-practice"
                        }
                      />
                    </div>
                  </Grid>
                </Grid>

                {pendingPractices
                  .slice()
                  .reverse()
                  .map((practice, index) => {
                    let parsedPractice = practice.practice;

                    try {
                      while (typeof parsedPractice === "string") {
                        parsedPractice = JSON.parse(parsedPractice);
                      }
                    } catch (error) {
                      console.error(error);
                      parsedPractice = {};
                    }

                    const datePart = new Date(
                      practice.updated_at,
                    ).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });

                    const timePart = new Date(
                      practice.updated_at,
                    ).toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <Grid
                        item
                        xs={11}
                        md={8}
                        component={Link}
                        to={`/practice/${practice.id}`}
                        key={practice.id}
                        style={{
                          paddingTop: "25px",
                          display: visibleSectionPending ? "block" : "none",
                          textDecoration: "none",
                        }}
                      >
                        <div className="card_practice">
                          <Link
                            to={`/practice/${practice.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                marginBottom: "0px",
                                fontSize: "16px",
                                marginLeft: "20px",
                                marginRight: "20px",
                              }}
                            >
                              #{practice.id} -{" "}
                              {parsedPractice?.Incarico?.Nome_pratica || "N/A"}{" "}
                              - Inviata il {datePart} alle {timePart}{" "}
                            </Typography>
                            <Typography variant="body2"></Typography>
                          </Link>
                        </div>
                      </Grid>
                    );
                  })}
              </>
            )}

            {draftPractices.length !== 0 && (
              <>
                <Grid
                  item
                  xs={11}
                  md={8}
                  style={{
                    display: "flex",
                    marginTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <Grid item xs={10.5}>
                    {" "}
                    {draftPractices.length > 0 ? (
                      <Typography
                        className="color-blue-dark"
                        sx={{
                          fontSize: {
                            xs: "18px !important",
                            sm: "20px !important",
                            md: "22px !important",
                          },
                          fontWeight: 600,
                        }}
                      >
                        Richieste in bozza
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={1.5}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div onClick={toggleSectionDraft}>
                      <div
                        className={
                          visibleSectionDraft
                            ? "icon-less-practice"
                            : "icon-plus-practice"
                        }
                      />
                    </div>
                  </Grid>
                </Grid>

                {draftPractices
                  .slice()
                  .reverse()
                  .map((practice, index) => {
                    let parsedPractice = practice.practice;
                    const isLast = index === draftPractices.length - 1;

                    try {
                      while (typeof parsedPractice === "string") {
                        parsedPractice = JSON.parse(parsedPractice);
                      }
                    } catch (error) {
                      console.error(error);
                      parsedPractice = {};
                    }

                    const datePart = new Date(
                      practice.updated_at,
                    ).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });

                    const timePart = new Date(
                      practice.updated_at,
                    ).toLocaleTimeString("it-IT", {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <>
                        <Grid
                          item
                          xs={11}
                          md={8}
                          key={practice.id}
                          style={{
                            paddingTop: "25px",
                            display: visibleSectionDraft ? "flex" : "none",
                            paddingBottom: isLast ? "120px" : "0",
                            justifyContent: "space-between",
                            textDecoration: "none",
                          }}
                        >
                          <Grid
                            item
                            xs={10}
                            component={Link}
                            to={`/practice/${practice.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <div className="card_practice">
                              <Link
                                to={`/practice/${practice.id}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  gutterBottom
                                  style={{
                                    marginBottom: "0px",
                                    fontSize: "16px",
                                    marginLeft: "20px",
                                    marginRight: "20px",
                                  }}
                                >
                                  #{practice.id} -{" "}
                                  {parsedPractice?.Incarico?.Nome_pratica ||
                                    "N/A"}{" "}
                                  - Creata il {datePart} alle ore {timePart}
                                </Typography>
                                <Typography variant="body2"></Typography>
                              </Link>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={1.5}
                            style={{ height: "100%" }}
                            onClick={() => openModalDeletePractice(practice.id)}
                          >
                            <div className="remove_practice">
                              <div className="icon-remove-practice" />
                            </div>
                          </Grid>
                        </Grid>
                      </>
                    );
                  })}
              </>
            )}

            <div style={{ paddingTop: "220px" }} />

            {approvedPractices.length === 0 &&
              pendingPractices.length === 0 &&
              draftPractices.length === 0 && (
                <div
                  style={{
                    width: "500px",
                    marginTop: "50px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    alignItems: "center",
                    marginLeft: "30px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{
                      fontSize: "24px",
                      fontWeight: 600,
                      marginBottom: "30px",
                    }}
                  >
                    Nessuna richiesta creata
                  </Typography>

                  <div className="empty_practice" />
                </div>
              )}
          </Grid>
        </Grid>

        {/* box button  */}
        <Grid
          container
          className="bg-blue-dark"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            padding: "15px 0px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0px 0px",
            }}
          >
            <Grid
              item
              xs={6}
              sm={5}
              style={{
                display:
                  user &&
                  (isToolsDomain
                    ? [1, 91].includes(user.id)
                    : [1, 2, 3, 6].includes(user.id))
                    ? "flex"
                    : "none",
                justifyContent: "start",
                alignItems: "center",
                padding: "0px 0px",
              }}
            >
              {/* sistemare css se utente non è FD  */}

              {user &&
              (isToolsDomain
                ? [1, 91].includes(user.id)
                : [1, 2, 3, 6].includes(user.id)) ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "15px",
                  }}
                >
                  <Switch
                    checked={isAdmin}
                    onChange={handleToggle}
                    sx={{
                      width: { xs: 46 },
                      height: 20,
                      padding: 0,
                      "& .MuiSwitch-switchBase": {
                        padding: 0.5,
                        "&.Mui-checked": {
                          transform: "translateX(26px)",
                          color: "#fff",
                          "& + .MuiSwitch-track": {
                            backgroundColor: "#bc2957",
                            opacity: 1,
                          },
                        },
                      },
                      "& .MuiSwitch-thumb": {
                        width: 12,
                        height: 12,
                      },
                      "& .MuiSwitch-track": {
                        borderRadius: 34 / 2,
                        backgroundColor: "rgba(211, 211, 211, 0.76)",
                        opacity: 1,
                        transition: "background-color 0.2s",
                      },
                    }}
                  />
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "12px", sm: "14px" },
                      fontWeight: 500,
                      marginLeft: { xs: "5px", sm: "10px" },
                    }}
                  >
                    {isAdmin
                      ? "Profilo Approver attivo"
                      : "Profilo Approver disattivato"}
                  </Typography>
                </div>
              ) : null}
            </Grid>
            <Grid
              item
              xs={5.5}
              sm={6.5}
              sx={{
                display: "flex",
                justifyContent:
                  user &&
                  (isToolsDomain
                    ? [1, 91].includes(user.id)
                    : [1, 2, 3, 6].includes(user.id))
                    ? { xs: "end", sm: "start" }
                    : "center",
                alignItems: "center",
                padding: "0px 0px",
                marginRight: "10px",
              }}
            >
              <Button
                style={{ width: "200px" }}
                onClick={handleModalClick}
                className="button-bg-purple"
              >
                <Typography
                  className="color-light"
                  sx={{
                    textTransform: "initial",
                    fontSize: { xs: "16px", sm: "18px" },
                    fontWeight: 500,
                  }}
                >
                  {" "}
                  Nuova richiesta
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>

      {deletePractice && (
        <Modal open={deletePractice} onClose={closeDeletePracticeModal}>
          <ModalError
            modalInfo={true}
            title="Elimina bozza"
            descriptionOne="Attenzione! L'eliminazione di una bozza è un'azione irreversibile con cui vengono cancellati definitivamente tutti i progressi della bozza."
            descriptionTwo="Sei sicuro di voler procedere?"
            copyButton="Sì, elimina"
            confirm={deletePracticeCall}
            onClose={closeDeletePracticeModal}
          />
        </Modal>
      )}

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <ModalNewPractice
          errors={fieldErrors}
          onClose={handleCloseModal}
          confirm={createPractice}
          handlePracticeUpdate={handlePracticeUpdate}
          practice={practice}
        />
      </Modal>
    </>
  );
};

export default Home;
